import { render } from "./stronaWiadomosci.vue?vue&type=template&id=10cfabf3&scoped=true"
import script from "./stronaWiadomosci.vue?vue&type=script&lang=js"
export * from "./stronaWiadomosci.vue?vue&type=script&lang=js"

import "./stronaWiadomosci.vue?vue&type=style&index=0&id=10cfabf3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cfabf3"]])

export default __exports__